import React, { useEffect } from "react";
import { getObjectives } from "../../api/championResearchApi";
import { aggregatePositionalStats } from "../../api/data_parser/aggregator";
import { useCombatStats, useObjectives } from "lib/hooks/tierlistHooks";

export function usePositionalBreakdown(state, setState, rank) {
  const getCombatStats = useCombatStats({ rank: rank, patch: "9_24" });
  const getObjectives = useObjectives({ rank: rank, patch: "9_24" });

  useEffect(() => {
    setState({ ...state, loading: true });
    Promise.all([
      getCombatStats().then((res) => {
        return res.json();
      }),
      getObjectives().then((res) => {
        return res.json();
      }),
    ])
      .then(([combatData, objectivesData]) => {
        let aggregate = aggregatePositionalStats(combatData, objectivesData);
        setState({ ...state, [rank]: aggregate, loading: false });
      })
      .catch((error) => {
        setState({ ...state, error: error });
        console.error("Error with promise:", error);
      });
  }, [rank]);
}
